import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"

import { AppShell } from "@/components/layout/app-shell"
import { ReviewProperties } from "@/features/reviews/components/review-properties"
import { ReviewSidebar } from "@/features/reviews/components/review-sidebar"
import { reviewQueries } from "@/queries/reviews"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/reviews/$reviewId"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(reviewQueries.detail(params.reviewId)),
  component: ReviewWorkspaceLayout,
})

function ReviewWorkspaceLayout() {
  const { reviewId } = Route.useParams()
  const { data: review } = useSuspenseQuery(reviewQueries.detail(reviewId))

  return (
    <AppShell
      sidebar={<ReviewSidebar review={review} />}
      aside={<ReviewProperties review={review} />}
    >
      <Outlet />
    </AppShell>
  )
}
